

































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DeleteModal extends Vue {
  @Prop() private type!: number

  private doDelete () {
    this.$emit('do-delete')
  }
  private closeDeleteModal () {
    this.$emit('close-delete-modal')
  }
}
